export default __webpack_public_path__ + "static/media/ThnkingDue.b1039aec.gif";